import { api } from "./api";

export const getClientByPhone = async (params = "") => {
    const response = await api.get(`/client/phone_number?phone_number=${params}`);
    
    return response;
};

export const getClientDetails = async (id: string) => {
    const response = await api.get(`/client/${id}`);
    
    return response;
}


export const listClients = async (page: number, pageSize: number, query: string) => {
    const response = await api.get(`/clients/all?page=${page}&pageSize=${pageSize}&query=${query}`);
    
    return response;
};

export const createClient = async ({
    first_name,
    last_name,
    phone_number,
    country_code,
}: any) => {
    const response = await api.post("/client", {
        first_name,
        last_name,
        phone_number,
        country_code,
    });

    return response;
};

export const createClientOnline = async ({
    first_name,
    last_name,
    phone_number,
    country_code,
    email,
}: any) => {
    const response = await api.post("/client/new/online", {
        first_name,
        last_name,
        phone_number,
        country_code,
        email,
    });

    return response;
}

export const requestVerificationCode = async ({
    phone_number,
    email,
}: any) => {
    const response = await api.post("/client/verification/request", {
        phone_number,
        email,
    });
    
    return response;
}

export const validateVerificationCode = async ({
    phone_number,
    code,
}: any) => {
    const response = await api.post("/client/verification/validate", {
        phone_number,
        code,
    });

    return response;
}

export const resendVerificationCodeEmail = async ({
    phone_number,
    email,
}: any) => {
    const response = await api.post("/client/verification/resend-email", {
        phone_number,
        email,
    });

    return response;
}

export const updateClient = async({
    id,
    first_name,
    last_name,
    phone_number,
    country_code,
}: any) => {
    const response = await api.put(`/client/${id}`, {
        id,
        first_name,
        last_name,
        phone_number,
        country_code,
    });
    
    return response;
};
